import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'app-opd-type-selection',
    templateUrl: './opd-type-selection.component.html',
    styleUrls: ['./opd-type-selection.component.scss'],
    standalone: false
})
export class OpdTypeSelectionComponent implements OnInit {
  @Input() care_type: any;
  @Input() checkDisabled: boolean = false;
  private _selectedOpdType: String;
  @Output() opdType = new EventEmitter<any>();

  constructor(
    private commonService: CommonService,
  ) { }

  get selectedOpdType(): String {
    return this.care_type && this.care_type.length ? this.care_type[0].id : this._selectedOpdType;
  }

  set selectedOpdType(value: String) {
    this._selectedOpdType = value;
  }

  ngOnInit(): void {
    this.selectedOpdType = this.care_type[0].id
  }

  changeOpdType(event: any) {
    if(this.commonService.readQueryParams('f__k') && localStorage.getItem('CurrentResource')){
      sessionStorage.removeItem("f__k_"+localStorage.getItem('CurrentResource'));
    }
    // if(this.commonService.readQueryParams('p__no')){
    //   var snapshot = this.route.snapshot;
    //   var params = { ...snapshot.queryParams };
    //   params["p__no"] = 0;
    //   var url = this.router.createUrlTree([], { relativeTo: this.route, queryParams: params, queryParamsHandling: '' }).toString()
    //   this.locationCommon.replaceState(url);
    //   this.router.navigate(['.'], { relativeTo: this.route, queryParams: params, replaceUrl: true, queryParamsHandling: '' });//maintain history so that user could go back  //(uncommenting because router params was not updating)
    // }
    if (!this.checkDisabled)
      this.opdType.emit(event.target.value);
    else
      this.selectedOpdType = this.care_type[0].id
  }

}
